import { PlusCircle, AlertTriangle, Users, Calendar } from 'lucide-react';

export const QuickActions = ({ 
  onNewAppointment, 
  onUrgentCase, 
  onViewWaitlist 
}) => {
  const actions = [
    {
      label: 'New Appointment',
      icon: PlusCircle,
      onClick: onNewAppointment,
      color: 'bg-uzima-maroon-50 text-uzima-maroon-500 hover:bg-blue-100'
    },
    {
      label: 'Register Urgent Case',
      icon: AlertTriangle,
      onClick: onUrgentCase,
      color: 'bg-red-50 text-red-600 hover:bg-red-100'
    },
    {
      label: 'View Waitlist',
      icon: Users,
      onClick: onViewWaitlist,
      color: 'bg-yellow-50 text-yellow-600 hover:bg-yellow-100'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className={`flex items-center p-4 rounded-lg transition-colors duration-200 ${action.color}`}
          >
            <action.icon className="h-5 w-5 mr-3" />
            <span className="font-medium">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};